// extracted by mini-css-extract-plugin
module.exports = {"input":"Input_input__DE3Dg","active":"Input_active__2M-Ou"};